/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Paginator, SortingDirectionEnum } from '@models';
import { AnagraficaService } from '@shared/services/anagrafica.service';
import { UtenteService } from '@shared/services/utente.service';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PagesGestioneUtenteApprovaUtenteResolver implements Resolve<Observable<any>> {

    constructor(
        private utenteService: UtenteService,
        private anagraficaService: AnagraficaService,
    ) { }

    resolve(): Observable<any> {
        return forkJoin([
            this.utenteService.getInApprovazione(new Paginator().getQueryPaginator([{ field: 'id', direction: SortingDirectionEnum.DESC }])),
            this.anagraficaService.getEnte(),
            this.anagraficaService.getRuolo(),
        ]).pipe(
            map(([
                responseUtentiInApprovazione,
                responseAnagraficaEnte,
                responseAnagraficaRuolo,
            ]) => {
                return {
                    items: responseUtentiInApprovazione,
                    datalist: {
                        ente: responseAnagraficaEnte,
                        ruolo: responseAnagraficaRuolo,
                    },
                };
            })
        )
    }

}